import React from 'react'
import './invite-students.scss'
import SessionCache from '../../routes/session-cache'
import { Modal, ModalBody } from 'reactstrap'
import { Constants, ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'
import CommonUtils from '../../../utility/common-utilities'
import SchoolApi from '../../../apis/school'
import Dropdown from '../../common/dropdown-v2/dropdown'
import CommonApi from '../../../apis/common'

class InviteStudents extends React.Component {
  state = {
    mobileNumber: '',
    email: '',
    isWhatsappInvited: false,
    countryCodeDropdown: []
  }

  constructor(props) {
    super(props)
    let user = SessionCache.getUser()
    this.user = user
    this.state.teachers = [
      { mobileNumber: user.mobileNumber, countryCode: user.countryCode }
    ]

    this.getCountryCodes()
  }

  getCountryCodes(payload = {}) {
    CommonApi.getCountryCodeList(payload)
      .then(response => {
        let data = response.response
        if (data.length) {
          this.setState({ countryList: data })
          let countryCodeDropdown = this.buildCountryCodeDropdown(data)
          this.setState({ countryCodeDropdown })
        }
      })
      .catch(err => { })
  }

  buildCountryCodeDropdown(list = []) {
    let countryCodeDropdown = []
    let countryCodeHash = {}
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      if (!countryCodeHash[item.dialCode]) {
        countryCodeHash[item.dialCode] = item
        countryCodeDropdown.push({
          title: `${item.name} ${item.dialCode}`,
          value: item.dialCode
        })
      }
    }
    this.setState({ hashedCountryCode: countryCodeHash })
    return countryCodeDropdown
  }

  onCountryCodeSearch(value, index) {
    if (value.length > 2 || !value) {
      this.countryCodeIndex = index
      this.getCountryCodes({ name: `/${value}` })
    }
  }

  onSelectCountryCode(option, index) {
    const { teachers } = this.state
    const countryCode = option?.value
    teachers[index].countryCode = countryCode
    this.setState({ teachers })
  }

  showToaster(type, message) {
    this.setState(
      {
        showToaster: true,
        toasterMessage: message,
        toasterType: type
      },
      () => {
        setTimeout(() => {
          this.hideToaster()
        }, 3000)
      }
    )
  }

  hideToaster() {
    this.setState({
      showToaster: false
    })
  }

  copyLink = _ => {
    var dummy = document.createElement('textarea')
    // dummy.style.display = 'none'
    document.body.appendChild(dummy)
    dummy.value = `Dear Students,

    Countingwell School has started using Countingwell for assigning and managing your Maths homework. Hereafter, we will start assigning you homework, tests and revision/practice tests through the Countingwell mobile app.
    
    
    ⛳Instruction:
    
    1. Download the Countingwell App from this link: ${'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
      this.user.schoolInfo.schoolCode}
      2. Register on the app or login if you have already registered
      3. Go to My Profile on the Countingwell app and the enter the school code: ${this.user.schoolInfo.schoolCode
      }
    4. Tap on My Homeworks card on the Countingwell app to see the list of your assigned homework and start completing the homework.  

    Download the Countingwell app from the above link, sign up and confirm.

    From Management,
    Countingwell School`
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.showToaster('info', 'Copied')
  }

  onChangeMobile = (event, key, index) => {
    const { teachers } = this.state
    const mobileNumber = event.target.value

    teachers[index].mobileNumber = mobileNumber
    this.setState({ teachers })

  }

  validateAllMobileNumbers = () => {
    const { teachers } = this.state
    let isValid = true
    for (let i = 0; i < teachers.length; i++) {
      const teacher = teachers[i]
      const mobileNumber = teacher.mobileNumber
      const countryCode = teacher.countryCode
      const countryCodeDetail = this.state.hashedCountryCode[countryCode]
      const validateCountryCode = CommonUtils.validateMobileNumber(
        mobileNumber,
        countryCodeDetail
      )
      if (!validateCountryCode) {
        teacher.isInvalidMobile = true
        teachers[i] = teacher
        this.setState({ teachers })
        isValid = false
      } else {
        teacher.isInvalidMobile = false
        teachers[i] = teacher
        this.setState({ teachers })
      }
      if (i === teachers.length - 1) return isValid
    }
  }

  allowEdit = key => {
    this.setState({
      ['allow' + key]: true,
      ['disable' + key]: true
    })
  }

  onContinue = _ => {
    this.props.onContinue()
  }

  sendInvitation = _ => {
    const { teachers } = this.state
    const isValid = this.validateAllMobileNumbers()
    if (!isValid) return

    let payload = {
      teachers,
      schoolCode: this.user.schoolInfo.schoolCode,
      adminName: this.user.name,
      schoolName: this.user.schoolInfo?.name,
    }
    this.setState({
      isInviteSubmit: true
    })
    SchoolApi.sendStudentInvitations(payload)
      .then(response => {
        this.setState({
          isInviteSubmit: false,
          teachers: [{ mobileNumber: this.user.mobileNumber, countryCode: this.user.countryCode }]
        })
        // this.props.onClose(true)
        this.showToaster("info", "Message shared successfully on Whatsapp")
      })
      .catch(err => {
        this.showToaster('error', 'Something went wrong')
        this.setState({
          isInviteSubmit: false
        })
      })
  }

  removeTeacher = index => {
    const { teachers } = this.state;
    teachers.splice(index, 1)
    this.setState({
      teachers
    })
  }

  addNewTeacher = _ => {
    const { teachers } = this.state;
    teachers.push({ mobileNumber: "", countryCode: "+91" })
    this.setState({
      teachers
    })
  }

  render() {
    const {
      toasterMessage,
      toasterType,
      mobileNumber,
      isInviteSubmit,
      showToaster,
      countryCodeDropdown,
      countryCode,
      isInvalidMobile,
      teachers
    } = this.state
    return (
      <Modal
        className='cw-custom-modal custom-toaster-modal'
        isOpen={true}
        toggle={this.props.onClose}
        size={'lg'}
      >
        <ModalBody>
          <div className=''>
            <div className='pt-2 pb-4'>
              <span className='text-right'>
                <img
                  className='close-icon cursor-pointer'
                  src={getImageSource(ImageConstants.CROSS)}
                  onClick={this.props.onClose}
                />
              </span>
            </div>
            <div>
              <div className='teachers-list invite-teachers'>
                <div className='row'>
                  <div className='col'>
                    <div className='text-center'>
                      <strong className='header-text'>
                        INVITE STUDENTS VIA WHATSAPP
                      </strong>
                    </div>
                    <div className='mt-5'>
                      <div className='invite-participants center-box'>
                        <div className='row share-container mt-2 my-2'>
                          <div className='col-11 copy-note '>
                            Alternately, you can enter a WhatsApp number below and click “Send Invite” to send this link via WhatsApp to your colleagues. You can even send it to yourself and then forward it to others from your WhatsApp number.
                            <a
                              className='share-link'
                              href={
                                'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
                                this.user.schoolInfo.schoolCode
                              }
                              target='_blank'
                            >
                              {'https://t2m3p.app.link/idcLs5rNInb?schoolCode=' +
                                this.user.schoolInfo.schoolCode}
                            </a>
                          </div>
                          <div className='col-1'>
                            <a
                              className='clone-link cursor-pointer'
                              onClick={this.copyLink}
                            >
                              <img
                                className='clone-icn'
                                src={getImageSource(ImageConstants.CLONE_ICON)}
                              />
                            </a>
                          </div>
                        </div>
                        <div className='mt-5'>
                          {teachers.map((teacher, index) => (
                            <>
                              <div className='input-container' key={index}>
                                <div className={`input-box d-inline-block  ${(teacher.isInvalidMobile && teacher.mobileNumber)
                                  ? 'invalid'
                                  : ''
                                  }`}>
                                  {countryCodeDropdown?.length && (
                                    <div className='cw-country-code d-inline-block'>
                                      <Dropdown
                                        key='countryCode'
                                        placeholder='Search country code'
                                        options={countryCodeDropdown}
                                        onSelect={option =>
                                          this.onSelectCountryCode(option, index)
                                        }
                                        text='title'
                                        onSearch={value =>
                                          this.onCountryCodeSearch(value)
                                        }
                                        style={{ background: '#F6F7F5' }}
                                        value={teacher.countryCode}
                                      />
                                    </div>
                                  )}
                                  <span className='cw-separator'></span>
                                  <input
                                    className={`cw-mobile-number cw-input-left`} //${!allowmobileNumber&& 'not-editable'}
                                    placeholder='Enter Mobile Number'
                                    value={teacher.mobileNumber}
                                    onChange={e =>
                                      this.onChangeMobile(
                                        e,
                                        'mobileNumber',
                                        index
                                      )
                                    }
                                  />
                                </div>
                                <div>
                                  <img
                                    className='close-icon cursor-pointer'
                                    onClick={_ => this.removeTeacher(index)}
                                    src={getImageSource(ImageConstants.DELETE_RED)}
                                  />
                                </div>
                              </div>
                              <div className='col'>
                                {teacher.isInvalidMobile && (
                                  <span className='invalid-text'>
                                    Enter valid phone number
                                  </span>
                                )}
                              </div>
                            </>
                          ))}
                          <div className='add-teacher text-right'><span className='cursor-pointer' onClick={this.addNewTeacher}>+ ADD WHATSAPP NO</span></div>
                        </div>
                        <div className='mt-5 text-center'>
                          {!isInviteSubmit &&
                            <button className={!isInviteSubmit ? "cw-button-primary cw-button-mod" : "cw-button-disabled"} onClick={() => !isInviteSubmit && this.sendInvitation()}>
                              SEND INVITE
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {showToaster ? (
                <ToasterComponent message={toasterMessage} type={toasterType} position="bottom-center" />
              ) : (
                ''
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}

export default InviteStudents
